import { create } from 'zustand';

const useCaseABPStore = create((set) => ({
    context: null,
    template: {},
    message: [],
    stringTemplate: '',
    setContext: (value) => set({ context: value }),
    setTemplate: (value) => set({ template: value }),
    setStringTemplate: (value) => set({ stringTemplate: value })
}));

export default useCaseABPStore;